import * as alert from './alert.actions';

export interface State {
  alerts: any[];
}

const initialState: State = {
  alerts: [],
};

export function reducer(state = initialState, action: alert.Actions): State {
  const alerts = state.alerts;
  switch (action.type) {
    case alert.SUCCESS:
      alerts.unshift({ type: 'alert-success', message: action.payload, closed: false });
      return Object.assign({}, { alerts });

    case alert.WARNING:
      alerts.unshift({ type: 'alert-warning', message: action.payload, closed: false });
      return Object.assign({}, { alerts });

    case alert.DANGER:
      alerts.unshift({ type: 'alert-danger', message: action.payload, closed: false });
      return Object.assign({}, { alerts });

    case alert.CLOSE:
      alerts[action.payload].cloased = true;
      return Object.assign({}, { alerts });

    case alert.REMOVE:
      alerts.pop();
      return Object.assign({}, { alerts });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// /Users/shwld/project/shwld/home-counter/app_src/src/app/store/alert/alert.reducer.ts